angular.module('core')
  .directive('sortableTableHeaders', function() {
    return {
      restrict: 'A',
      scope: {
        columns: '=',
        item: '=',
        transclude: '@',
        tooltips:'=?'
      },
      replace: true,
      transclude: true,
      templateUrl: '/resources/core/partials/sortable-table-headers.html',
      controller: 'SortableTableHeadersController'
    };
  });

angular.module('core').controller('SortableTableHeadersController', ['$scope', 'tableSort', '$state', 'tooltips', function($scope, $tableSort, $state, tooltips) {

  if(!$scope.tooltips) {
    $scope.tooltips = tooltips;
  }

  $scope.handleColumnClick = function(column) {
    $tableSort.handleColumnClick(column);
  };

  $scope.getColumnStyle = function(column, isFirst) {
    var classes = '';
    if(isFirst) {
      classes += 'column-indicator';
    }

    //if there is state (reload page or deep linked)
    if ($state.params.order && $state.params.sort) {
      if($state.params.sort === column.id) {
        classes += ' active-column';
        if ($tableSort.sort.order === $tableSort.ASCENDING) {
          classes += ' ascending';
        } else {
          classes += ' descending';
        }
      }
      return classes;
    }

    // set to default if no state set
    if (!$tableSort.sort.column) {
      if($scope.columns[$tableSort.sortIndex].id === column.id) {
        classes += ' active-column';
        if ($tableSort.sort.order === $tableSort.ASCENDING) {
          classes += ' ascending';
        } else {
          classes += ' descending';
        }
      }
      return classes;
    }
  };

  $scope.$watch('columns', $tableSort.initializeSort);
}]);
